import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatErr } from "../lib/api";
import Navbar from "../components/Navbar";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account creato!");
      nav("/onboarding");
    } catch (ex) {
      setErr(formatErr(ex.response?.data?.detail) || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-serif-display text-4xl text-[#1E3F33]">Crea account</h1>
        <p className="mt-2 text-[#6B6B6B]">Bastano 30 secondi. Nessuna carta richiesta.</p>
        <form onSubmit={submit} className="mt-8 card-flat p-6 space-y-4">
          <div>
            <label className="label-caps block mb-2">Nome / Ragione sociale</label>
            <input data-testid="register-name" required value={name} onChange={e=>setName(e.target.value)}
              className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
          </div>
          <div>
            <label className="label-caps block mb-2">Email</label>
            <input data-testid="register-email" type="email" required value={email} onChange={e=>setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
          </div>
          <div>
            <label className="label-caps block mb-2">Password (min 6 caratteri)</label>
            <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={e=>setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
          </div>
          {err && <div data-testid="register-error" className="text-sm text-[#A83C22]">{err}</div>}
          <button data-testid="register-submit" disabled={loading} className="btn-lift w-full py-3 bg-[#1E3F33] text-white rounded-md hover:bg-[#152D24] disabled:opacity-60">
            {loading ? "Creazione…" : "Crea account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#6B6B6B]">
          Hai già un account? <Link to="/accedi" data-testid="link-login" className="text-[#1E3F33] underline">Accedi</Link>
        </p>
      </div>
    </div>
  );
}
